<template>
    <el-container>
		<el-row :gutter="20">
			<el-col class="card-col" :span="12">
				<el-card class="text-container">
					<div class="card-title">时间戳转换（支持秒和毫秒）</div>
					<div style="margin:0 auto; margin-top: 15px">
						<el-input placeholder="输入时间戳" v-model="timestamp2" class="input-with-select">
						    <el-button slot="append" icon="el-icon-caret-right" @click="timestampTotime"></el-button>
						</el-input>
					</div>
					<div class="g-card">
						<span class="label">北京时间：</span>
					    <span class="content">{{ timeFormat2 }}</span>
					    <div class="copy">
					        <el-button
					            size="mini"
					            round
					            icon="el-icon-document-copy"
					            v-clipboard:copy="timeFormat2"
					            v-clipboard:success="onCopy"
					            v-clipboard:error="onError"
					        ></el-button>
					    </div>
					</div>
				</el-card>
			</el-col>
			
			<el-col class="card-col" :span="12">
				<el-card class="text-container">
					<div class="card-title">时间转换</div>
					<div style="margin:0 auto; margin-top: 15px">
						<el-input placeholder="输入时间" v-model="timeFormat1" class="input-with-select">
						    <el-button slot="append" type="primary" icon="el-icon-caret-right" @click="timeTotimestamp"></el-button>
						</el-input>
					</div>
					<div class="g-card">
						<span class="label">时间戳（秒/m）：</span>
					    <span class="content">{{ timeunix1 }}</span>
					    <div class="copy">
					        <el-button
					            size="mini"
					            round
					            icon="el-icon-document-copy"
					            v-clipboard:copy="timeunix1.toString()"
					            v-clipboard:success="onCopy"
					            v-clipboard:error="onError"
					        ></el-button>
					    </div>
					</div>
					<div class="g-card">
						<span class="label">时间戳（毫秒/ms）：</span>
					    <span class="content">{{ timestamp1 }}</span>
					    <div class="copy">
					        <el-button
					            size="mini"
					            round
					            icon="el-icon-document-copy"
					            v-clipboard:copy="timestamp1.toString()"
					            v-clipboard:success="onCopy"
					            v-clipboard:error="onError"
					        ></el-button>
					    </div>
					</div>
				</el-card>
			</el-col>
		</el-row>
		
		<el-row style="margin-top: 20px;">
			<el-card class="text-container">
				<div class="card-title">当前时间</div>
				<div class="button-group">
					<el-button-group>
						<el-tooltip
							class="item"
							effect="dark"
							content="当前时间"
							placement="top"
						>
							<el-button type="primary" icon="el-icon-watch-1" @click="onChangeTime"></el-button>
						</el-tooltip>
						
						<el-tooltip
							class="item"
							effect="dark"
							:content="isRunTime?'暂停':'运行'"
							placement="top"
						>
							<el-button type="primary" :icon="isRunTime?'el-icon-video-pause':'el-icon-video-play'" @click="clearRunTime"></el-button>
						</el-tooltip>
					</el-button-group>
				</div>
				<div class="g-card">
					<span class="label">时间戳（秒/m）：</span>
					<span class="content">{{ timeunix }}</span>
					<div class="copy">
						<el-button
							size="mini"
							round
							icon="el-icon-document-copy"
							v-clipboard:copy="timeunix.toString()"
							v-clipboard:success="onCopy"
							v-clipboard:error="onError"
						></el-button>
					</div>
				</div>
				<div class="g-card">
					<span class="label">时间戳（毫秒/ms）：</span>
					<span class="content">{{ timestamp }}</span>
					<div class="copy">
						<el-button
							size="mini"
							round
							icon="el-icon-document-copy"
							v-clipboard:copy="timestamp.toString()"
							v-clipboard:success="onCopy"
							v-clipboard:error="onError"
						></el-button>
					</div>
				</div>
				<div class="g-card">
					<span class="label">北京时间：</span>
					<span class="content">{{ timeFormat }}</span>
					<div class="copy">
						<el-button
							size="mini"
							round
							icon="el-icon-document-copy"
							v-clipboard:copy="timeFormat"
							v-clipboard:success="onCopy"
							v-clipboard:error="onError"
						></el-button>
					</div>
				</div>
			</el-card>
		</el-row>
		
    </el-container>
</template>

<script>
	const moment = require('moment');
	export default {
		name: "g-timeFormat",
		data() {
			return {
				inputValue: "",
				timestamp: "",
				timeunix: "",
				timeFormat: "",
				
				timeFormat1:"",
				timeunix1:"",
				timestamp1:"",
				
				timestamp2:"",
				timeFormat2:"",
				
				isRunTime:false,
			};
		},
		watch: {
			inputValue(newval, oldval){
				if (Number(newval).toString().length != 13) {
					this.timeunix =  Number(newval);
					this.timestamp =  moment(Number(newval)*1e3).valueOf();
					this.timeFormat = moment(Number(this.timestamp)).format("YYYY-MM-DD HH:mm:ss");
					return
				}
				this.timeunix =  moment(Number(newval)).unix();
				this.timestamp =  moment(Number(newval)).valueOf();
				this.timeFormat = moment(Number(this.timestamp)).format("YYYY-MM-DD HH:mm:ss");
			}
		},
		methods: {
			onChangeTime(){
				this.inputValue = moment().valueOf();
			},
			// 复制成功时的回调函数
			onCopy(e) {
				this.$message.success("内容已复制到剪切板！");
			},
			// 复制失败时的回调函数
			onError(e) {
				this.$message.error("抱歉，复制失败！");
			},
			runTime(){
				this.isRunTime = true
				this.runTimeObj = setTimeout(()=>{
					this.onChangeTime()
					this.runTime()
				}, 1000)
			},
			clearRunTime(){
				if(this.isRunTime){
					this.isRunTime = false
					clearTimeout(this.runTimeObj)
				}else{
					this.runTime()
				}
			},
			
			timeTotimestamp(){
				if(this.timeFormat1==''){
					this.$message.error("请输入内容！");
					return
				}
				
				this.timeunix1 =  moment(this.timeFormat1).unix();
				this.timestamp1 =  moment(this.timeFormat1).valueOf();
			},
			timestampTotime(){
				if(this.timestamp2==''){
					this.$message.error("请输入内容！");
					return
				}
				
				if (Number(this.timestamp2).toString().length != 13) {
					let nowTimestamp =  moment(Number(this.timestamp2)*1e3).valueOf();
					this.timeFormat2 = moment(nowTimestamp).format("YYYY-MM-DD HH:mm:ss");
				}else{
					this.timeFormat2 = moment(Number(this.timestamp2)).format("YYYY-MM-DD HH:mm:ss");
				}
			}
		},
		mounted() {
			this.onChangeTime()
			this.runTime()
		},
		beforeDestroy(){
			this.clearRunTime()
		}
	};
</script>

<style lang="scss" scoped>
	.el-container /deep/{
		flex-flow: column;
		font-size: 14px;
		
		.card-title{
			font-size: 16px;
		}
		
		.el-row{
			.el-col{
				display: flex;
				flex:1;
				height: 100%;
				
				.el-card{
					width: 100%;
					.el-card__body{
						overflow: auto;
						display: flex;
						flex: 1;
						flex-flow: column;
						height: 100%;
					}
				}
			}
		}
		
		.button-group{
			text-align: center;
		}
		.label{
			color: #909399;
		}
	}
</style>
